import React, { useState } from 'react';

const thStyle = {
  padding: '4px 8px',
  textAlign: 'left',
  fontWeight: '600',
  borderBottom: '1px solid #c8ddf0',
};

const tdStyle = {
  padding: '4px 8px',
  verticalAlign: 'top',
};

/**
 * Collapsible panel showing relevant TKB field rules for a failing test result.
 * Props: rules: [{ name, type, description, cardinality, pageNumber }]
 */
const TkbFieldRulesPanel = ({ rules, onDismiss }) => {
  const [expanded, setExpanded] = useState(false);
  const [dismissed, setDismissed] = useState(new Set());

  if (!rules || rules.length === 0) return null;

  // Track dismissed rules by stable rule.name instead of array index to avoid
  // issues when rules array ordering changes.
  const visible = rules.filter((r) => !dismissed.has(r.name));

  const dismiss = (e, name) => {
    e.stopPropagation();
    const next = new Set(dismissed);
    next.add(name);
    setDismissed(next);
    if (onDismiss) {
      onDismiss(rules.filter((r) => !next.has(r.name)));
    }
  };

  return (
    <div style={{ marginTop: '8px', fontSize: '13px' }}>
      <div
        onClick={() => setExpanded(open => !open)}
        style={{ cursor: 'pointer', color: '#005b99', userSelect: 'none' }}
      >
        {expanded ? '▾' : '▸'} TKB field rules ({visible.length})
      </div>
      {expanded && visible.length > 0 && (
        <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '6px', fontSize: '12px' }}>
          <thead>
            <tr style={{ background: '#f0f7ff' }}>
              <th style={thStyle}>Field</th>
              <th style={thStyle}>Type</th>
              <th style={thStyle}>Cardinality</th>
              <th style={{ ...thStyle, width: '45%' }}>Description</th>
              <th style={thStyle}>Page</th>
              <th style={{ ...thStyle, width: '24px' }}></th>
            </tr>
          </thead>
          <tbody>
            {rules.map((rule) => dismissed.has(rule.name) ? null : (
              <tr key={`${rule.name}`} style={{ borderBottom: '1px solid #eee' }}>
                <td style={tdStyle}><code>{rule.name}</code></td>
                <td style={tdStyle}>{rule.type}</td>
                <td style={tdStyle}>{rule.cardinality}</td>
                <td style={tdStyle}>{rule.description}</td>
                <td style={tdStyle}>{rule.pageNumber}</td>
                <td style={{ ...tdStyle, textAlign: 'center' }}>
                  <button
                    type="button"
                    onClick={(e) => dismiss(e, rule.name)}
                    title="Ta bort"
                    style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', fontSize: '14px', padding: 0, lineHeight: 1 }}
                  >×</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {expanded && visible.length === 0 && (
        <p style={{ marginTop: '6px', color: '#9ca3af', fontSize: '12px' }}>Alla regler borttagna.</p>
      )}
    </div>
  );
};

export default TkbFieldRulesPanel;
